import { fromJS } from "immutable";
import ACTIONS from "../constants";

const initialState = fromJS({
  error: "",
  pageLoading: false,
  budgetLoading: false,
  budgets: [],
  budgetPagination: {},
});

export default function budgetReducers(state = initialState, action) {
  switch (action.type) {
    // Budget sorting
    case ACTIONS.SORT_BUDGETS.PENDING: {
      return state.set("error", "").set("pageLoading", true);
    }

    case ACTIONS.SORT_BUDGETS.SUCCESS: {
      return state
        .set("pageLoading", false)
        .set("error", "")
        .set("budgets", action.data.data)
        .set("budgetPagination", action.data.pagination);
    }
    case ACTIONS.SORT_BUDGETS.ERROR: {
      return state.set("pageLoading", false).set("error", action.error);
    }

    // Budget lisitng
    case ACTIONS.BUDGETS.PENDING: {
      return state.set("error", "").set("pageLoading", true);
    }
    case ACTIONS.BUDGETS.SUCCESS: {
      return state
        .set("pageLoading", false)
        .set("error", "")
        .set("budgets", action.data.data)
        .set("budgetPagination", action.data.pagination);
    }
    case ACTIONS.BUDGETS.ERROR: {
      return state.set("pageLoading", false).set("error", action.error);
    }

    // Create Budget
    case ACTIONS.CREATE_BUDGET.PENDING: {
      return state.set("budgetLoading", true).set("error", "");
    }
    case ACTIONS.CREATE_BUDGET.SUCCESS: {
      return state
        .set("budgetLoading", false)
        .set("error", "")
        .set("budgets", action.data.data)
        .set("budgetPagination", action.data.pagination);
    }
    case ACTIONS.CREATE_BUDGET.ERROR: {
      return state.set("error", action.error).set("budgetLoading", false);
    }

    // Update Budget
    case ACTIONS.UPDATE_BUDGET.PENDING: {
      return state.set("budgetLoading", true).set("error", "");
    }
    case ACTIONS.UPDATE_BUDGET.SUCCESS: {
      return state
        .set("budgetLoading", false)
        .set("error", "")
        .set("budgets", action.data.data)
        .set("budgetPagination", action.data.pagination);
    }
    case ACTIONS.UPDATE_BUDGET.ERROR: {
      return state.set("error", action.error).set("budgetLoading", false);
    }

    // Delete Budget
    case ACTIONS.DELETE_BUDGET.PENDING: {
      return state.set("error", "").set("budgetLoading", true);
    }
    case ACTIONS.DELETE_BUDGET.SUCCESS: {
      return state
        .set("error", "")
        .set("budgetLoading", false)
        .set("budgets", action.data.data)
        .set("budgetPagination", action.data.pagination);
    }
    case ACTIONS.DELETE_BUDGET.ERROR: {
      return state.set("error", action.error).set("budgetLoading", false);
    }

    default: {
      return state;
    }
  }
}
